<template>
  <layout>
    <page-header :actions="actions" :header="pageHeader" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps">
        <template slot="booking_amount" slot-scope="{ item }">
          {{ item.booking_amount | currency(item.currency_label) }}
        </template>
        <template slot="amount" slot-scope="{ item }">
          {{ item.amount | currency(item.currency_label) }}
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import DeferredPaymentsApi from '../../../console/src/affiliates/DeferredPaymentsApi'

export default {
  name: 'DeferredPayments',

  components: {
    AdminTable,
  },

  data() {
    return {
      totals: {
        pending: null,
      },

      actions: [],

      // Table resource configuration
      tableProps: {
        base: 'payouts',
        apiBuilder: () => {
          return new DeferredPaymentsApi({
            include: 'booking',
          })
        },
        columns: [
          {
            key: 'created_at',
            label: this.$t('deferred_payments.date'),
            component: 'value-date',
            config: {
              time: false,
            },
            sortable: true,
          },
          {
            key: 'booking.number',
            label: this.$t('deferred_payments.booking_number'),
            formatter: value => (value ? `#${value}` : null),
          },
          {
            key: 'booking_amount',
            label: this.$t('deferred_payments.booking_amount'),
          },
          {
            key: 'discount',
            label: this.$t('deferred_payments.discount'),
            formatter: value => (value ? `${value}%` : null),
          },
          {
            key: 'status_label',
            label: this.$t('deferred_payments.status'),
          },
          {
            key: 'amount',
            label: this.$t('deferred_payments.amount'),
          },
        ],

        searchFields: [
          {
            component: 'select-field',
            attribute: 'where[status]',
            placeholder: this.$t('deferred_payments.status'),
            options: [
              {
                label: this.$t('affiliates.payout_status.pending'),
                value: 'pending',
              },
              {
                label: this.$t('affiliates.payout_status.complete'),
                value: 'complete',
              },
            ],
          },
          {
            component: 'text-field',
            attribute: 'where[booking_number]',
            placeholder: this.$t('deferred_payments.booking_number'),
          },
        ],

        rowActions: () => [],

        bulkActions: () => {
          return [
            {
              label: this.$t('affiliates.generate_invoice'),
              handler: selected => {
                this.generateInvoice(selected)
              },
            },
          ]
        },
      },
    }
  },

  computed: {
    pageHeader() {
      return this.$t('affiliates.deferred_payments')
    },
  },

  async mounted() {
    this.totals = await new DeferredPaymentsApi().totals()

    if (this.totals.pending) {
      this.actions.push({
        id: 'create',
        text: this.$t('affiliates.generate_invoice'),
        icon: 'icon-plus-circle2',
        onClick: () => {
          this.generateInvoice()
        },
      })
    }
  },

  methods: {
    generateInvoice(ids) {
      new DeferredPaymentsApi()
        .process(ids)
        .then(result => {
          this.$toast.success(result.message)
          this.$refs.table.refresh()
        })
        .catch(result => {
          this.$toast.error(result.data.message)
        })
    },
  },
}
</script>
